module.exports = __webpack_public_path__ + "img/DE05800.a2af38a5.png";